import { render, staticRenderFns } from "./GroupEditView.vue?vue&type=template&id=2b112f6c&scoped=true&"
import script from "./GroupEditView.vue?vue&type=script&lang=js&"
export * from "./GroupEditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b112f6c",
  null
  
)

export default component.exports